<template>
  <div class="contact-details-main">
    <div :style="{ width: showDetails ? '50%' : '100%' }">
      <Input
        placeholder="Contact Person"
        :inputValue.sync="contactPerson"
        :isDisabled="viewMode"
        :errorMessage.sync="contactPersonError"
        ref="contactPerson"
      />
      <div v-if="!viewMode" class="add-remove-contact">
        <button @click="addContact" :disabled="showDetails">Add</button>
        <button @click="deleteClicked" :disabled="showDetails" style="margin-left: 3px">Delete</button>
      </div>
      <TableBox
        title="Contacts"
        style="height: calc(100% - 57px)"
        :additionalButtons="viewMode ? [] : editButtons"
        :tableData="contactList"
        :selectedRow.sync="selectedContact"
        :maxSelection="-1"
        :hideColumns="contactHideColumns"
        @buttonClicked="editButtonClicked"
      />
    </div>
    <div v-if="showDetails" :style="{ marginLeft: '5px', width: showDetails ? '50%' : '0' }">
      <div style="display: flex; justify-content: flex-end; margin-bottom: 5px">
        <button @click="saveContact">{{ editMode ? 'Edit' : 'Add' }}</button>
        <button @click="cancelClicked" style="margin-left: 5px">Cancel</button>
      </div>
      <Input placeholder="Ref ID" :inputValue.sync="refid" :isDisabled="true" :isRequired="true" />
      <Input
        placeholder="Name"
        :inputValue.sync="name"
        :isDisabled="viewMode"
        :isRequired="true"
        :errorMessage.sync="nameError"
        validator="text,50,uppercase"
      />
      <div style="display: flex">
        <Input
          placeholder="Position"
          :inputValue.sync="position"
          :isDisabled="viewMode"
          :errorMessage.sync="positionError"
        />
        <Input
          style="margin-left: 5px"
          placeholder="Department"
          :inputValue.sync="department"
          :isDisabled="viewMode"
          :errorMessage.sync="departmentError"
        />
      </div>
      <AddressFormV2
        :address.sync="addressData"
        :postcodes="postcodes"
        :states="states"
        :countries="countries"
        :addressErrors.sync="addressErrors"
        :viewMode="viewMode"
      />
      <div style="display: flex">
        <Input placeholder="Phone No" :inputValue.sync="phone" :isDisabled="viewMode" :errorMessage.sync="phoneError" />
        <Input
          style="margin-left: 5px"
          placeholder="Mobile No"
          :inputValue.sync="mobile"
          :isDisabled="viewMode"
          :errorMessage.sync="mobileError"
        />
      </div>
      <Input placeholder="Fax No" :inputValue.sync="fax" :isDisabled="viewMode" :errorMessage.sync="faxError" />
      <Input placeholder="Email" :inputValue.sync="email" :isDisabled="viewMode" :errorMessage.sync="emailError" />
      <Input
        placeholder="Remarks"
        :inputValue.sync="remarks"
        :isDisabled="viewMode"
        :errorMessage.sync="remarksError"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {},
  data: function () {
    return {
      contactPerson: '',
      contactPersonError: '',
      contactPersonRef: '',
      showDetails: false,
      editMode: false,
      editButtons: [{ text: 'Edit', index: 0, width: 60 }],
      editIndex: -1,

      contactList: [],
      selectedContact: [],
      contactHideColumns: ['Cust_Code', 'contactaction'],

      refid: '',
      name: '',
      nameError: '',
      position: '',
      positionError: '',
      department: '',
      departmentError: '',
      addressData: {
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        postcode: '',
        city: '',
        state: '',
        country: '',
      },
      addressErrors: {
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        city: '',
      },
      phone: '',
      phoneError: '',
      mobile: '',
      mobileError: '',
      fax: '',
      faxError: '',
      email: '',
      emailError: '',
      remarks: '',
      remarksError: '',
    };
  },
  props: {
    viewMode: { type: Boolean, default: false },
    showInputs: { type: Boolean, default: false }, // show/hide input fields, use .sync
    contacts: {
      type: Array,
      default: function () {
        return [];
      },
    },
    states: {
      type: Array,
      default: function () {
        return [];
      },
    },
    countries: {
      type: Array,
      default: function () {
        return [];
      },
    },
    postcodes: {
      type: Array,
      default: function () {
        return [];
      },
    },
    personError: { type: String, default: '' },
    person: { type: String, default: '' },
    // Public Methods
    // focusContactPersonInput()
  },
  methods: {
    addContact: function () {
      this.clearFields();
      this.editMode = false;
      this.showDetails = true;
      this.$emit('update:showInputs', true);
      let highestID = 0;
      for (let c of this.contactList) {
        if (c['ID'] > highestID) {
          highestID = c['ID'];
        }
      }
      this.refid = (parseInt(highestID) + 1).toString();
    },
    editButtonClicked: function (btn, data) {
      if (this.viewMode) return;
      this.showDetails = true;
      this.$emit('update:showInputs', true);
      this.editMode = true;
      this.editIndex = this.contactList.findIndex((l) => l['ID'] === data['ID']);
      this.populateEditData(data);
    },
    populateEditData: function (data) {
      this.refid = data['ID'];
      this.name = data['ContactPerson'];
      this.position = data['TitlePosition'];
      this.department = data['Department'];
      this.addressData['addressLine1'] = data['Addr1'];
      this.addressData['addressLine2'] = data['Addr2'];
      this.addressData['addressLine3'] = data['Addr3'];
      this.addressData['addressLine4'] = data['Addr4'];
      this.addressData['postcode'] = data['PostCode'];
      this.addressData['city'] = data['City'];
      this.addressData['state'] = data['State'];
      this.addressData['country'] = data['Country'];
      this.phone = data['TelNo'];
      this.mobile = data['MobileNo'];
      this.fax = data['FaxNo'];
      this.email = data['Email'];
      this.remarks = data['Remarks'];
    },
    saveContact: async function () {
      if (this.viewMode) return;

      if (this.checkFields()) {
        return;
      }

      let duplicateContactIndex;
      if (this.editIndex > -1) {
        // if a contact is being edited
        duplicateContactIndex = this.contactList.findIndex(
          (contact, index) => contact.ContactPerson.trim() === this.name.trim() && index !== this.editIndex,
        );
      } else {
        // else if a new contact is being created
        duplicateContactIndex = this.contactList.findIndex(
          (contact) => contact.ContactPerson.trim() === this.name.trim(),
        );
      }

      if (duplicateContactIndex !== -1) {
        const replaceResponse = await this.$showAlert(
          'warning',
          'Duplicate Contact',
          `The contact person ${this.name.trim()} already exists.\nDo you want to replace it instead?`,
          [
            { text: 'Yes', color: 'red', textColor: 'white' },
            { text: 'No', color: 'lightgray' },
          ],
        );

        if (replaceResponse === 'No') {
          return;
        }
      }

      let temp = this.contactList;
      this.contactList = [];

      let highestID = 0;
      for (let c of temp) {
        if (c['ID'] > highestID) {
          highestID = c['ID'];
        }
      }
      let contact = {
        ID: null, // placeholder, will be populated below

        ContactPerson: this.name,
        TitlePosition: this.position,
        Department: this.department,
        Addr1: this.addressData['addressLine1'],
        Addr2: this.addressData['addressLine2'],
        Addr3: this.addressData['addressLine3'],
        Addr4: this.addressData['addressLine4'],
        PostCode: this.addressData['postcode'],
        City: this.addressData['city'],
        State: this.addressData['state'],
        Country: this.addressData['country'],
        TelNo: this.phone,
        MobileNo: this.mobile,
        FaxNo: this.fax,
        Email: this.email,
        Remarks: this.remarks,
      };

      if (duplicateContactIndex !== -1) {
        // if user is trying to replace the duplicate contact
        contact.ID = temp[duplicateContactIndex].ID; // copy the ID of the duplicate contact
        contact.contactaction = temp[duplicateContactIndex].contactaction === 'N' ? 'N' : 'E'; // if the duplicate contact is newly added, remain as new, else mark as edited

        if (this.editIndex > -1) {
          // if a contact is being edited
          temp.splice(duplicateContactIndex, 1, contact); // replace the duplicate contact
          temp.splice(this.editIndex, 1); // delete the contact being edited
        } else {
          temp.splice(duplicateContactIndex, 1, contact);
        }
      } else if (this.editIndex > -1) {
        // else if there is no duplicate contact and if a contact is being edited
        contact.ID = this.refid;
        contact.contactaction = temp[this.editIndex].contactaction === 'N' ? 'N' : 'E'; // if the contact being edited is newly added, remain as new, else mark as edited
        temp.splice(this.editIndex, 1, contact);
      } else {
        // else if there is no duplicate contact and a new contact is being added
        contact.ID = (parseInt(highestID) + 1).toString();
        contact.contactaction = 'N';
        temp.push(contact);
      }

      this.$nextTick(() => {
        this.contactList = temp;
        this.clearFields();
        this.showDetails = false;
        this.$emit('update:showInputs', false);
        this.editIndex = -1;

        this.selectedContact = [];

        this.$emit('update:contacts', this.contactList);
      });
    },
    cancelClicked: function () {
      this.showDetails = false;
      this.$emit('update:showInputs', false);
      // this.selectedContact = [];
    },
    deleteClicked: function () {
      if (this.selectedContact.length == 0) {
        this.$showAlert('error', 'No Contact Selected', 'Please select at least 1 contact to delete.');
      } else {
        let temp = this.contactList;
        this.selectedContact.forEach((s) => {
          let index = temp.findIndex((l) => l['ID'] === s['ID']);
          temp.splice(index, 1);
        });
        this.contactList = [];

        this.$nextTick(() => {
          this.contactList = temp;
          this.selectedContact = [];

          this.$emit('update:contacts', this.contactList);
        });
      }
    },
    clearFields: function () {
      this.refid = '';
      this.name = '';
      this.nameError = '';
      this.position = '';
      this.positionError = '';
      this.department = '';
      this.departmentError = '';
      this.addressData['addressLine1'] = '';
      this.addressData['addressLine2'] = '';
      this.addressData['addressLine3'] = '';
      this.addressData['addressLine4'] = '';
      this.addressData['postcode'] = '';
      this.addressData['city'] = '';
      this.addressData['state'] = '';
      this.addressData['country'] = '';
      this.addressErrors['addressLine1'] = '';
      this.addressErrors['addressLine2'] = '';
      this.addressErrors['addressLine3'] = '';
      this.addressErrors['addressLine4'] = '';
      this.addressErrors['city'] = '';
      this.phone = '';
      this.phoneError = '';
      this.mobile = '';
      this.mobileError = '';
      this.fax = '';
      this.faxError = '';
      this.email = '';
      this.emailError = '';
      this.remarks = '';
      this.remarksError = '';
      this.editIndex = -1;
    },
    checkFields: function () {
      let error = false;
      if (!this.name) {
        this.nameError = 'Name is required!';
        error = true;
      } else {
        if (this.name.length > 50) {
          this.nameError = 'Name cannot exceed 50 characters!';
          error = true;
        }
      }
      if (this.position.length > 50) {
        this.positionError = 'Position cannot exceed 50 characters!';
        error = true;
      }
      if (this.department.length > 35) {
        this.departmentError = 'Department cannot exceed 35 characters!';
        error = true;
      }
      if (this.addressData.addressLine1.length > 40) {
        this.addressErrors.addressLine1 = 'Address Line 1 cannot exceed 40 characters!';
        error = true;
      }
      if (this.addressData.addressLine2.length > 40) {
        this.addressErrors.addressLine2 = 'Address Line 2 cannot exceed 40 characters!';
        error = true;
      }
      if (this.addressData.addressLine3.length > 40) {
        this.addressErrors.addressLine3 = 'Address Line 3 cannot exceed 40 characters!';
        error = true;
      }
      if (this.addressData.addressLine4.length > 40) {
        this.addressErrors.addressLine4 = 'Address Line 4 cannot exceed 40 characters!';
        error = true;
      }
      if (this.addressData.city.length > 30) {
        this.addressErrors.city = 'City cannot exceed 30 characters!';
        error = true;
      }
      if (this.phone.length > 20) {
        this.phoneError = 'Phone cannot exceed 20 characters!';
        error = true;
      }
      if (this.mobile.length > 20) {
        this.mobileError = 'Mobile cannot exceed 20 characters!';
        error = true;
      }
      if (this.fax.length > 20) {
        this.faxError = 'Fax cannot exceed 20 characters!';
        error = true;
      }
      if (this.email.length > 100) {
        this.emailError = 'Email cannot exceed 100 characters!';
        error = true;
      }
      if (this.remarks.length > 200) {
        this.remarksError = 'Remarks cannot exceed 200 characters!';
        error = true;
      }
      return error;
    },
    // Public Methods
    focusContactPersonInput: function () {
      this.$refs['contactPerson'].setFocus();
    },
  },
  async mounted() {
    this.contactPerson = this.person;
    this.contactList = this.contacts;
    this.contactPersonError = this.personError;
    this.showDetails = this.showInputs;
  },
  watch: {
    contactPerson: function (val) {
      this.$emit('update:person', val);
    },
    contactPersonError: function (val) {
      this.$emit('update:personError', val);
    },
    personError: function (val) {
      this.contactPersonError = val;
    },
    showInputs: function (val) {
      this.showDetails = val;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.contact-details-main {
  height: calc(100%);
  width: 100%;
  display: flex;
}

.add-remove-contact {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 3px;
}
</style>
